// extracted by mini-css-extract-plugin
module.exports = {"content_heading":"NewsContent-module--content_heading--17HgN","content_news":"NewsContent-module--content_news--1fRpE"};